const ProductData =()=>{

const products =[
    {
     "Product": "Empty",
     "Setpoint": 0,
     "Specific_Heat": 0,
     "Heat_of_Respiration": 0
    },
    {
     "Product": "Chill",
     "Setpoint": 0,
     "Specific_Heat": 3800,
     "Heat_of_Respiration": 0.03
    },
    {
     "Product": "Deep Frozen",
     "Setpoint": -29,
     "Specific_Heat": 3500,
     "Heat_of_Respiration": 0
    },
    {
     "Product": "Fresh",
     "Setpoint": 7,
     "Specific_Heat": 4000,
     "Heat_of_Respiration": 0.04
    },
    {
     "Product": "Frozen",
     "Setpoint": -25,
     "Specific_Heat": 3500,
     "Heat_of_Respiration": 0
    },
    {
     "Product": "Apples",
     "Setpoint": -1,
     "Specific_Heat": 3810,
     "Heat_of_Respiration": 0.012
    },
    {
     "Product": "Apricots",
     "Setpoint": 0,
     "Specific_Heat": 3870,
     "Heat_of_Respiration": 0.016
    },
    {
     "Product": "Asparagus",
     "Setpoint": 0,
     "Specific_Heat": 4030.0000000000005,
     "Heat_of_Respiration": 0.16
    },
    {
     "Product": "Avocados",
     "Setpoint": 4,
     "Specific_Heat": 3670,
     "Heat_of_Respiration": 0.32
    },
    {
     "Product": "Bananas",
     "Setpoint": 13,
     "Specific_Heat": 3560,
     "Heat_of_Respiration": 0.1
    },
    {
     "Product": "Beets",
     "Setpoint": 0,
     "Specific_Heat": 3910,
     "Heat_of_Respiration": 0.018
    },
    {
     "Product": "Blackberries",
     "Setpoint": -1,
     "Specific_Heat": 3910,
     "Heat_of_Respiration": 0.06
    },
    {
     "Product": "Blueberries",
     "Setpoint": -1,
     "Specific_Heat": 3830,
     "Heat_of_Respiration": 0.019
    },
    {
     "Product": "Broccoli",
     "Setpoint": 0,
     "Specific_Heat": 4010,
     "Heat_of_Respiration": 0.06
    },
    {
     "Product": "Brussels Sprouts",
     "Setpoint": 0,
     "Specific_Heat": 3900,
     "Heat_of_Respiration": 0.06
    },
    {
     "Product": "Butternut Squash",
     "Setpoint": 10,
     "Specific_Heat": 4070.0000000000005,
     "Heat_of_Respiration": 0.29
    },
    {
     "Product": "Cabbage",
     "Setpoint": 0,
     "Specific_Heat": 4019.9999999999995,
     "Heat_of_Respiration": 0.03
    },
    {
     "Product": "Carrots",
     "Setpoint": 0,
     "Specific_Heat": 3920,
     "Heat_of_Respiration": 0.02
    },
    {
     "Product": "Cauliflower",
     "Setpoint": 0,
     "Specific_Heat": 4019.9999999999995,
     "Heat_of_Respiration": 0.05
    },
    {
     "Product": "Celery",
     "Setpoint": 0,
     "Specific_Heat": 4070.0000000000005,
     "Heat_of_Respiration": 0.02
    },
    {
     "Product": "Cranberries",
     "Setpoint": 2,
     "Specific_Heat": 3910,
     "Heat_of_Respiration": 0.013
    },
    {
     "Product": "Cucumbers",
     "Setpoint": 10,
     "Specific_Heat": 4090,
     "Heat_of_Respiration": 0.075
    },
    {
     "Product": "Figs",
     "Setpoint": 0,
     "Specific_Heat": 3700,
     "Heat_of_Respiration": 0.03
    },
    {
     "Product": "Gooseberries",
     "Setpoint": -1,
     "Specific_Heat": 3950,
     "Heat_of_Respiration": 0.023
    },
    {
     "Product": "Grapefruit",
     "Setpoint": 10,
     "Specific_Heat": 3960,
     "Heat_of_Respiration": 0.035
    },
    {
     "Product": "Grapes",
     "Setpoint": -1,
     "Specific_Heat": 3710,
     "Heat_of_Respiration": 0.006
    },
    {
     "Product": "Green Beans",
     "Setpoint": 4,
     "Specific_Heat": 3990,
     "Heat_of_Respiration": 0.12
    },
    {
     "Product": "Honeydew Melons",
     "Setpoint": 7,
     "Specific_Heat": 3920,
     "Heat_of_Respiration": 0.0238
    },
    {
     "Product": "Kale",
     "Setpoint": 0,
     "Specific_Heat": 3820,
     "Heat_of_Respiration": 0.01
    },
    {
     "Product": "Leeks",
     "Setpoint": 0,
     "Specific_Heat": 3770,
     "Heat_of_Respiration": 0.035
    },
    {
     "Product": "Lemons",
     "Setpoint": 7,
     "Specific_Heat": 3940,
     "Heat_of_Respiration": 0.047
    },
    {
     "Product": "Lettuce",
     "Setpoint": 0,
     "Specific_Heat": 4090,
     "Heat_of_Respiration": 0.03
    },
    {
     "Product": "Limes",
     "Setpoint": 9,
     "Specific_Heat": 3930,
     "Heat_of_Respiration": 0.012
    },
    {
     "Product": "Mangoes",
     "Setpoint": 13,
     "Specific_Heat": 3740,
     "Heat_of_Respiration": 0.1334
    },
    {
     "Product": "Mushrooms",
     "Setpoint": 0,
     "Specific_Heat": 3990,
     "Heat_of_Respiration": 0.11
    },
    {
     "Product": "Okra",
     "Setpoint": 7,
     "Specific_Heat": 3970,
     "Heat_of_Respiration": 0.259
    },
    {
     "Product": "Onions",
     "Setpoint": 0,
     "Specific_Heat": 3950,
     "Heat_of_Respiration": 0.0087
    },
    {
     "Product": "Oranges",
     "Setpoint": 0,
     "Specific_Heat": 3810,
     "Heat_of_Respiration": 0.0092
    },
    {
     "Product": "Parsnips",
     "Setpoint": 0,
     "Specific_Heat": 3740,
     "Heat_of_Respiration": 0.03
    },
    {
     "Product": "Peaches",
     "Setpoint": -1,
     "Specific_Heat": 3910,
     "Heat_of_Respiration": 0.015
    },
    {
     "Product": "Pears",
     "Setpoint": 0,
     "Specific_Heat": 3800,
     "Heat_of_Respiration": 0.012
    },
    {
     "Product": "Peas",
     "Setpoint": 0,
     "Specific_Heat": 3750,
     "Heat_of_Respiration": 0.14
    },
    {
     "Product": "Peppers",
     "Setpoint": 7,
     "Specific_Heat": 4010,
     "Heat_of_Respiration": 0.0427
    },
    {
     "Product": "Pineapples",
     "Setpoint": 7,
     "Specific_Heat": 3850,
     "Heat_of_Respiration": 0.1
    },
    {
     "Product": "Plums",
     "Setpoint": 0,
     "Specific_Heat": 3830,
     "Heat_of_Respiration": 0.007
    },
    {
     "Product": "Potatoes",
     "Setpoint": 4,
     "Specific_Heat": 3480,
     "Heat_of_Respiration": 0.02
    },
    {
     "Product": "Prunes",
     "Setpoint": 0,
     "Specific_Heat": 2560,
     "Heat_of_Respiration": 0.01
    },
    {
     "Product": "Radishes",
     "Setpoint": 0,
     "Specific_Heat": 4080,
     "Heat_of_Respiration": 0.035
    },
    {
     "Product": "Raspberries",
     "Setpoint": 0,
     "Specific_Heat": 3960,
     "Heat_of_Respiration": 0.06
    },
    {
     "Product": "Rhubarb",
     "Setpoint": 0,
     "Specific_Heat": 4050,
     "Heat_of_Respiration": 0.033
    },
    {
     "Product": "Sour Cherries",
     "Setpoint": 0,
     "Specific_Heat": 3850,
     "Heat_of_Respiration": 0.028
    },
    {
     "Product": "Strawberries",
     "Setpoint": 0,
     "Specific_Heat": 4000,
     "Heat_of_Respiration": 0.044
    },
    {
     "Product": "Sweet Cherries",
     "Setpoint": -1,
     "Specific_Heat": 3730,
     "Heat_of_Respiration": 0.014
    },
    {
     "Product": "Tomatoes",
     "Setpoint": 8,
     "Specific_Heat": 4080,
     "Heat_of_Respiration": 0.079
    },
    {
     "Product": "Turnips",
     "Setpoint": 0,
     "Specific_Heat": 4000,
     "Heat_of_Respiration": 0.0257
    },
    {
     "Product": "Watermelons",
     "Setpoint": 7,
     "Specific_Heat": 3970,
     "Heat_of_Respiration": 0.0223
    }
   ]

   return products;
}
export default ProductData;